import { useGetMyOrganizationSettings } from "@/api/orval/generated/organization";
import { FEATURE_FLAGS, useFeatureFlag } from "@/services/feature-flags/feature-flags";

/**
 * Whether on-demand irrigation should be shown for the current organization.
 *
 * Two gates: the rollout flag, plus a per-org opt-out for growers on long irrigation cycles who get
 * nothing from the feature. Once the flag opens globally this collapses to just the org setting.
 */
export function useOnDemandIrrigationEnabled(): boolean {
    const { isEnabled: isFlagEnabled } = useFeatureFlag(FEATURE_FLAGS.ON_DEMAND_IRRIGATION);
    const { data: settings } = useGetMyOrganizationSettings();

    // Stay hidden until the setting arrives: rendering the feature and then pulling it back shifts the
    // zone card under the user, and hiding is the safer wrong answer for an org that opted out.
    return isFlagEnabled && (settings?.onDemandIrrigationEnabled ?? false);
}
